{
  "base_password": "Senha",
  "base_loading": "Carregando...",
  "base_item": "Item",
  "base_date": "Data",
  "base_hour": "Hora",
  "base_description": "Descrição",
  "base_value": "Valor",
  "base_add": "Adicionar",
  "base_submit": "Finalizar",
  "base_product": "Produto",
  "base_confirm": "Confirmar",
  "base_quantity": "Qtd",
  "base_cancel": "Cancelar",
  "base_select": "Selecione",
  "base_code": "Código",

  "account_myPurchases": "Minhas compras",
  "account_view": "Visualizar",
  "account_emptyNotice": "Nenhuma compra encontrada.",
  "account_previous": "Anterior",
  "account_next": "Próxima",
  "account_itemsQuantity": "{quantity} item(s)",
  "account_sellNumber": "Pedido #{orderCode}",
  "account_log_out_button": "Terminar Sessão",
  "account_total_purchases": "Total",
  "account_sale_item_without_date": "Sem Agendamento",
  "account_sale_total_value": "Valor total",
  "account_sale_discount": "Desconto",
  "account_sale_date": "Data e hora",
  "account_sale_reschedule": "Reagendar",
  "account_sale_reservation_tariff": "Tarifas",
  "account_sale_reservation_voucher": "Ações",
  "account_sale_reservation_places": "Lugares",
  "account_sale_checkout": "Finalizar Compra",
  "account_sale_download_all": "Baixar Todos",
  "account_sale_reschedule_disabled": "Não é possível reagendar reservas promocionais. Contate o estabelecimento para maiores informações",
  "account_sale_reschedule_success_message": "Reagendamento confirmado com sucesso",
  "account_sale_voucher_revoketed": "Cancelado",
  "account_empty_state": "Você ainda não tem nenhuma compra",
  "account_sale_package_title": "{packageName} com {quantity} atividades",
  "account_sale_reschedule_tooltip": "Não é possível reagendar reservas promocionais. Contate o estabelecimento para maiores informações",
  "account_sale_voucher_pending": "Voucher Pendente",
  "account_sale_pending_voucher_info": "O pagamento da sua compra foi confirmado. <strong>O voucher está sendo gerado</strong> com o parceiro e em breve estará disponível.",
  "account_sale_download_all_vouchers_tooltip": "Voucher pendente, aguarde a confirmação",
  "account_sale_voucher_pending_status": "Aguardando confirmação",
  "account_sale_change_amount": "Acréscimo por Reagendamento",
  "account_sale_original_total_value": "Valor original da compra",
  "account_email_change_title": "Confirmação de troca de e-mail",
  "account_email_change_confirm_title": "Seus dados de cadastro foram atualizados.",
  "account_email_change_description": "Para continuar, informe seu e-mail atual. Vamos validar o código enviado para o novo endereço.",
  "account_email_change_confirm_description": "<strong><em>{app}</em></strong> atualizou os dados do seu cadastro.<br></br>Você concorda que seus dados sejam atualizados em nossa base de dados?",
  "account_email_change_current_email_label": "E-mail atual",
  "account_email_change_new_email_label": "Novo e-mail",
  "account_email_change_login_button": "Continuar",
  "account_email_change_confirm_button": "Concordo",
  "account_email_change_decline_button": "Não concordo",
  "account_email_change_success": "Troca de e-mail confirmada com sucesso.",
  "account_email_change_declined": "A troca de e-mail foi recusada.",
  "account_email_change_invalid_link": "Este link de confirmação é inválido ou está incompleto.",
  "account_email_change_error": "Não foi possível concluir a troca de e-mail. Tente novamente ou solicite um novo link.",

  "reservation_download": "Baixar",
  "reservation_rescheduling": "Reagendando...",
  "voucher_download": "Baixar",

  "reschedule_step_date": "Selecione uma data",
  "reschedule_step_time": "Selecione um horário",
  "reschedule_step_summary": "Confirme a seleção",
  "reschedule_go_back_button": "Voltar",
  "reschedule_confirm_button": "Confirmar",
  "reschedule_make_payment_button": "Realizar pagamento",
  "reschedule_go_forward_button": "Continuar",
  "reschedule_selected_date": "Data Selecionada",
  "reschedule_selected_time": "Horário selecionado",
  "reschedule_error_reschedulingLimitExceeded": "Limite de reagendamentos excedido",
  "reschedule_error_reschedulingToHigherTariffNotAllowed": "Não é possível reagendar para uma tarifa de maior valor",
  "reschedule_error_reschedulingToLowerTariffNotAllowed": "Não é possível reagendar para uma tarifa menor valor",
  "reschedule_error_reschedulingAntecedenceNotMet": "A antecedência para reagendamento deve ser de pelo menos {minAntecedence}",
  "reschedule_error_scheduleTimeMustDifferFromCurrent": "O horário selecionado deve ser diferente do horário atual",
  "reschedule_error_schedulingIsValid": "A data selecionada não é válida",
  "reschedule_error_invalidValue": "A data selecionada não é válida",
  "reschedule_days": "{count, plural, one {{count, number} dia} other {{count, number} dias}}",
  "reschedule_hours": "{count, plural, one {{count, number} hora} other {{count, number} horas}}",
  "reschedule_minutes": "{count, plural, one {{count, number} minuto} other {{count, number} minutos}}",
  "reschedule_charge_summary_alert_title": "Certifique-se de que a nova data está correta",
  "reschedule_charge_summary_alert_description": "O seu agendamento atual está marcado para {date}. Após confirmar, seu ingresso não dará mais acesso a essa data e você terá {remainingRescheduleCount} reagendamento(S) restante(s).",
  "reschedule_charge_summary_actual_schedule": "Reserva atual",
  "reschedule_charge_summary_new_schedule": "Nova reserva",
  "reschedule_charge_summary_total_to_pay": "Total a pagar",
  "reschedule_charge_summary_disclaimer": "A sua reserva do {date} está garantida até o reagendamento ser confirmado.",
  "reschedule_charge_summary_pay_button": "Realizar pagamento",
  "reschedule_info_remaining_reschedule_count": "Reagendamentos disponíveis: ",
  "reschedule_info_reschedule_until_title": "Prazo para solicitar reagendamento: ",
  "reschedule_history_old_reservation_value": "Reserva antiga: ",
  "reschedule_history_new_reservation_value": "Nova reserva: ",
  "reschedule_applied_message": "Reagendamento confirmado",
  "reschedule_expired_message": "O pagamento para finalizar o reagendamento expirou",
  "reschedule_pending_payment_message": "Realize o pagamento para o reagendamento para a data {date} ser confirmado.",
  "reschedule_pending_payment_message_title": "Reagendamento Pendente",
  "reschedule_info_reschedule_until_expired": "O prazo para solicitar reagendamento expirou",
  "reschedule_error_saleItemHasPayableSaleChanges": "A reserva possui reagendamento pendente de pagamento",

  "auth_processing": "Processando...",
  "auth_checkoutHeaderTitle": "Já tenho Conta",
  "auth_accountHeaderTitle": "Entrar",
  "auth_alreadyHaveAnAccount": "Já possuo conta",
  "auth_wantToSignup": "Quero me Cadastrar",
  "auth_signupPasswordInfo": "Ela deve conter no mínimo 8 caracteres, com ao menos uma letra maiúscula e uma letra minúscula",
  "auth_inputEmail": "E-mail",
  "auth_inputPassword": "Senha",
  "auth_labelPassword": "Senha",
  "auth_labelEmail": "E-mail",
  "auth_forgotPassword": "Esqueci minha senha",
  "auth_login": "Entrar",
  "auth_submit": "Enviar",
  "auth_registerMessage": "Não possui conta? Cadastre-se",
  "auth_createAccount": "Criar conta",
  "auth_labelName": "Nome",
  "auth_labelSurname": "Sobrenome",
  "auth_mailConfirmation": "Confirmar E-mail",
  "auth_passwordConfirmation": "Confirmar Senha",
  "auth_cellphone": "Celular",
  "auth_identity_cpf": "CPF",
  "auth_identity_cnpj": "CNPJ",
  "auth_cep": "CEP",
  "auth_corporate_name": "Razão social",
  "auth_cnpj_first_name": "Nome do representante legal",
  "auth_cnpj_last_name": "Sobrenome do representante legal",
  "auth_identity_passport": "Passaporte",
  "auth_identity_national_document": "Documento nacional",
  "auth_document": "Documento",
  "auth_nationality": "Nacionalidade",
  "auth_birthdate": "Data de nascimento",
  "auth_identity_type_cpf": "Sou pessoa física",
  "auth_identity_type_cnpj": "Sou pessoa jurídica",
  "auth_is_foreign": "Sou estrangeiro",
  "auth_termsRead": "Li e concordo com os ",
  "auth_terms": "Termos de Uso",
  "auth_termsAnd": " e ",
  "auth_policy": "Política de Privacidade",
  "auth_requiredCheckOfTermsAndPrivacyPolicy": "É necessário concordar com os Termos e Políticas de Privacidade para continuar",
  "auth_terms_close": "fechar",
  "auth_terms_loading": "Carregando...",
  "auth_signup": "Cadastrar",
  "auth_recoverPassword": "Recuperar senha",
  "auth_backToLogin": "Voltar ao login",
  "auth_code": "Código",
  "auth_resetPassword": "Redefinir senha",
  "auth_goBackButton": "Voltar",
  "auth_loginSubtitle": "Utilizamos apenas dados essenciais para a geração do voucher de consumo",
  "auth_passwordResetSubtitle": "Digite o e-mail cadastrado na plataforma para recuperar a senha",
  "auth_validCodeSubtitle": "Informe o código de 6 dígitos que foi enviado para",
  "auth_continue": "Continuar",
  "auth_didNotGetTheEmail": "Não recebeu o email?",
  "auth_clickHere": "Clique aqui",
  "auth_passwordRecoverySubtitle": "Digite abaixo sua nova senha para concluir o processo de redefinição de senha",
  "auth_redefinePassword": "Redefinir senha",
  "auth_messagePasswordModifiedSuccessFully": "Sua senha foi alterada com sucesso!",
  "auth_resendEmailInfo": "O código será Reenviado para o seguinte email:",
  "auth_fixEmail": "Corrigir email",
  "auth_messageAccountCreatedSuccessFully": "Sua conta foi criada com sucesso!",
  "auth_continueShopping": "Continuar a compra",
  "auth_emailUniquenessError_title": "E-mail já cadastrado",
  "auth_emailUniquenessError_message": "Identificamos que você já se cadastrou em um estabelecimento que utiliza a tecnologia de e-commerce da Planne, por isso, prossiga com a criação de uma nova senha para realizar o login simplificado.<br></br><br></br>Seus dados estão seguros e apenas são compartilhados com empresas autorizadas por você.",
  "auth_emailUniquenessError_action": "Criar nova senha",
  "auth_zipCode_max_length_error": "O CEP deve ter 8 dígitos",

  "auth_verify_phone_form_title": "Informar chave de acesso",
  "auth_verify_phone_form_subtitle": "Informe o código enviado por SMS para o telefone:",
  "auth_verify_phone_form_code": "Código",
  "auth_verify_phone_form_did_not_receive": "Não recebeu o sms?",
  "auth_verify_phone_form_resend": "Reenviar",
  "auth_verify_phone_form_submit": "Continuar",
  "auth_verify_phone_form_back": "Voltar",
  "auth_verify_phone_form_code_expires_in": "Você pode solicitar um novo código em",
  "auth_verify_phone_form_error_too_many_requests": "Não foi possível. Aguarde para solicitar um novo código",
  "auth_invalid_verification_code": "O código deve ter 6 caracteres",

  "checkout_confirmingYourPurchase": "Confirmando sua compra...",
  "checkout_awaiting_confirmation_message": "Estamos verificando a disponibilidade. Aguarde um instante antes de pagar.",
  "checkout_awaiting_confirmation_unavailable_title": "Não há disponibilidade",
  "checkout_awaiting_confirmation_unavailable_description": "Não foi possível confirmar sua reserva. Escolha outra data ou horário e tente novamente.",
  "checkout_awaiting_confirmation_unavailable_action": "Escolher outra data ou horário",
  "checkout_pendingSales": "Vendas pendentes:",
  "checkout_saleNumber": "Venda #{saleNumber}",
  "checkout_item": "Item",
  "checkout_totalValue": "Valor total:",
  "checkout_yourCartIsEmpty": "Seu carrinho está vazio!",
  "checkout_yourCartErrors": "O carrinho possui os seguintes erros:",
  "checkout_continueShopping": "Continuar comprando",
  "checkout_finishSale": "Finalizar minha compra",
  "checkout_placement": "Lugares:",
  "checkout_resource_extra_value": "Extra por lugares:",
  "checkout_additionals": "Adicionais",
  "checkout_invalidCoupon": "Cupom inválido",
  "checkout_removeCoupon": "Remover cupom",
  "checkout_couponCode": "Código do cupom",
  "checkout_addCoupon": "Adicionar cupom de desconto",
  "checkout_processingPayment": "Aguarde, o pagamento está sendo processado...",
  "checkout_expiredSale": "Venda expirada",
  "checkout_makeYourPurchaseAgain": "Por favor, realize a sua compra novamente.",
  "checkout_percentDiscount": "% de desconto",
  "checkout_unavailablePaymentOptions": "Opções de pagamento indisponíveis",
  "checkout_unavailablePaymentMethod": "Método de pagamento indisponível.",
  "checkout_securityCode": "Código de segurança",
  "checkout_validityMonth": "Mês de validade",
  "checkout_validityYear": "Ano de validade",
  "checkout_formInputPhonePlaceholder": "(99) 99999-9999",
  "checkout_formInputEmailPlaceholder": "seu@melhoremail.com",
  "checkout_formInputCpfPlaceholder": "000.000.000-00",
  "checkout_paymentIn": "Pagar em",
  "checkout_addressTitle": "Endereço",
  "checkout_addressZipCode": "Código Postal (CEP)",
  "checkout_addressCountry": "País",
  "checkout_addressState": "Estado",
  "checkout_addressStateHint": "Apenas a sigla. Ex.: RJ",
  "checkout_addressCity": "Cidade",
  "checkout_addressDistrict": "Bairro",
  "checkout_addressStreet": "Endereço",
  "checkout_addressNumber": "Número",
  "checkout_addressComplement": "Complemento",
  "checkout_nameAsInCard": "Nome",
  "checkout_nameAsInCardHint": "Conforme está no cartão",
  "checkout_identityMessage": "CPF do portador do cartão (ao deixar vazio, o CPF/CNPJ {num} será utilizado)",
  "checkout_expiredTry": "Sua tentativa anterior expirou, por favor tente novamente.",
  "checkout_fromValue": " De ",
  "checkout_toValue": " por ",
  "checkout_payWithPix": "Pagar com Pix",
  "checkout_copiedCode": "Código copiado!",
  "checkout_finishPaymentWithPix": "Finalize o pagamento usando o Pix!",
  "checkout_pixUseCameraDescription": "Você pode utilizar a câmera do seu celular para ler o QR Code ou copiar o código e pagar no aplicativo de seu banco:",
  "checkout_verifyingPayment": "Verificando pagamento",
  "checkout_qrCodeWithPixCode": "QR Code com código Pix",
  "checkout_copyCode": "Copiar código",
  "checkout_completePurchaseStepsTitle": "Para completar a sua compra siga os passos abaixo",
  "checkout_ongoingPixDescription": "Você ainda precisa pagar o Pix.     Você pode usar a opção de pagar por QR Code ou então copiar e colar o código e concluir o pagamento     utilizando seu aplicativo de preferência ou seu internet banking.",
  "checkout_remove": "Remover",
  "checkout_confirm": "Confirme o valor exibido, que precisa ser obrigatoriamente igual ao valor cobrado para evitar o cancelamento da transação, e as informações do recebedor (nome da instituição financeira: ",
  "checkout_nameOfReceiver": "nome da empresa recebedora: ",
  "checkout_atention": "Atenção:",
  "checkout_warning1": "<strong>Não faça o pagamento utilizando a função Transferência </strong>         <span>, pois a </span>         <strong> transação não será concluída e a devolução não ocorrerá de forma automática </strong>         <span>, sendo necessário que você entre em contato com nossa Central de Atendimento. </span>",
  "checkout_warning2": "<span>O prazo de confirmação do pagamento leva em </span>    <strong> média 10 segundos</strong>    <span> e depende da instituição financeira, portanto o tempo para processamento pode ser estendido.</span>",
  "checkout_warning3": "<strong>O QR Code fica válido por 5 minutos</strong>    <span>. Se não for pago nesse prazo, você precisará</span>    <strong> gerar uma nova cobrança Pix.</strong>",
  "checkout_units": "unidade(s)",
  "checkout_method_softdescriptor": "Na fatura do cartão, essa compra aparece em nome de",
  "checkout_cardNumber": "Nº do cartão",
  "checkout_postalCode": "CEP",
  "checkout_buyerInfoCollectHeaderTitle": "Informações adicionais",
  "checkout_buyerInfoCollectSubtitle": "Utilizamos apenas dados essenciais para a geração do voucher de consumo",
  "checkout_buyerInfoCollectProceed": "Continuar",
  "checkout_buyerInfoCollectStepback": "Voltar",
  "checkout_buyerInfoCollectFillWithSignupData": "Preencher com dados informados no cadastro",
  "checkout_tariff": "Tarifa",
  "checkout_step_login": "Entrar",
  "checkout_step_signup": "Criar Conta",
  "checkout_step_personal": "Dados pessoais",
  "checkout_step_payment": "Dados do pagamento",
  "checkout_step_payment_security_note": "Todas as compras efetuadas neste site são 100% seguras, incluindo seus dados pessoais e dados do seu cartão.",
  "checkout_purchase_summary": "Resumo da compra",
  "checkout_order_summary_title": "Resumo do pedido",
  "checkout_coupon_placeholder": "Cupom de desconto",
  "checkout_coupon_apply": "Aplicar",
  "checkout_coupon_affected_products": "Desconto aplicado somente aos produtos:",
  "checkout_view_more": "Ver mais",
  "checkout_view_product_details": "Ver detalhes dos produtos",
  "checkout_sold_by": "Vendido por",
  "checkout_tariffs_section": "Tarifas",
  "checkout_view_summary": "Ver resumo",
  "checkout_hide_summary": "Ocultar resumo",
  "checkout_discounts": "Descontos",
  "checkout_cart_summary_total": "Total: {total}",
  "checkout_cart_summary_products": "({count, plural, one {{count, number} produto} other {{count, number} produtos}})",
  "checkout_title": "Finalizar compra",
  "checkout_back_to_site": "Voltar para o site",
  "checkout_back": "Voltar",
  "checkout_auth_identification_title": "Acesse sua conta",
  "checkout_auth_identification_subtitle": "Crie ou acesse sua conta",
  "checkout_auth_email_label": "E-mail",
  "checkout_auth_identification_cta": "Continuar",
  "checkout_auth_or_divider": "OU",
  "checkout_auth_required_field": "Campo obrigatório",
  "checkout_auth_invalid_email": "E-mail inválido",
  "checkout_auth_generic_error_title": "Não foi possível continuar",
  "checkout_auth_generic_error": "Não foi possível processar sua solicitação agora. Tente novamente em instantes.",
  "checkout_auth_generic_error_retry": "Tentar novamente",
  "checkout_auth_login_title": "Acesse sua conta",
  "checkout_auth_login_existing_account_subtitle": "Esse email está associado a uma conta nos nossos marketplaces. Insira a senha para continuar ou, se preferir, receba um código por email para continuar sem senha.",
  "checkout_auth_login_password_subtitle": "Insira seu email e senha para continuar ou, se preferir, receba um código por email para continuar sem senha.",
  "checkout_auth_login_otp_subtitle": "Enviamos um código de 6 dígitos para <strong>{email}</strong>, digite-o abaixo para continuar.",
  "checkout_auth_password_label": "Senha",
  "checkout_auth_show_password": "Mostrar senha",
  "checkout_auth_hide_password": "Ocultar senha",
  "checkout_auth_forgot_password_prefix": "Esqueceu sua senha?",
  "checkout_auth_forgot_password_link": "Clique aqui para recuperar",
  "checkout_auth_continue_cta": "Continuar",
  "checkout_auth_continue_purchase_cta": "Continuar compra",
  "checkout_auth_login_with_code_cta": "Entrar com código",
  "checkout_auth_login_with_password_cta": "Entrar com senha",
  "checkout_auth_otp_label": "Insira o código enviado",
  "checkout_auth_otp_helper": "Enviamos um código para o seu e-mail",
  "checkout_auth_otp_resend_countdown": "Reenviar código em {seconds}s",
  "checkout_auth_otp_resend_cta": "Reenviar código",
  "checkout_auth_otp_sending": "Enviando código...",
  "checkout_auth_signup_link": "É sua primeira compra? Cadastre-se",
  "checkout_auth_signup_title": "Crie sua conta",
  "checkout_auth_signup_subtitle": "Preencha seus dados para continuar a compra.",
  "checkout_auth_signup_identity_type_label": "Tipo de conta",
  "checkout_auth_signup_person_title": "Sou pessoa física",
  "checkout_auth_signup_person_subtitle": "Atuo com meu CPF",
  "checkout_auth_signup_company_title": "Sou pessoa jurídica",
  "checkout_auth_signup_company_subtitle": "Atuo com meu CNPJ",
  "checkout_auth_signup_first_name_label": "Nome",
  "checkout_auth_signup_last_name_label": "Sobrenome",
  "checkout_auth_signup_legal_first_name_label": "Nome do representante legal",
  "checkout_auth_signup_legal_last_name_label": "Sobrenome do representante legal",
  "checkout_auth_signup_corporate_name_label": "Razão social",
  "checkout_auth_signup_cpf_label": "CPF",
  "checkout_auth_signup_cnpj_label": "CNPJ",
  "checkout_auth_signup_phone_label": "Celular",
  "checkout_auth_signup_legal_phone_label": "Celular do representante legal",
  "checkout_auth_signup_foreign_checkbox": "Sou estrangeiro",
  "checkout_auth_signup_nationality_label": "Nacionalidade",
  "checkout_auth_signup_foreign_document_label": "Documento",
  "checkout_auth_signup_foreign_document_type_label": "Tipo de documento",
  "checkout_auth_signup_foreign_document_identity": "Documento nacional",
  "checkout_auth_signup_foreign_document_passport": "Passaporte",
  "checkout_auth_signup_zip_code_label": "CEP",
  "checkout_auth_signup_postal_code_label": "Código postal (Opcional)",
  "checkout_auth_signup_postal_code_hint": "Deixe em branco se seu país não usa código postal.",
  "checkout_auth_signup_zip_code_help_link_label": "Não sei o meu CEP",
  "checkout_auth_signup_zip_code_help_title": "Não sabe seu CEP?",
  "checkout_auth_signup_zip_code_help_intro": "Usamos seu CEP pra confirmar seus dados com mais segurança no pagamento.",
  "checkout_auth_signup_zip_code_help_tip_before": "Verifique em uma conta de luz/água recente, correspondência recebida, ou busque no",
  "checkout_auth_signup_zip_code_help_link": "site dos Correios",
  "checkout_auth_signup_zip_code_help_tip_after": ".",
  "checkout_auth_signup_zip_code_help_close": "Fechar",
  "checkout_auth_signup_state_label": "Estado",
  "checkout_auth_signup_city_label": "Cidade",
  "checkout_auth_signup_district_label": "Bairro",
  "checkout_auth_signup_street_label": "Rua",
  "checkout_auth_signup_number_label": "Número",
  "checkout_auth_signup_complement_label": "Complemento",
  "checkout_auth_signup_password_confirmation_label": "Confirmar senha",
  "checkout_auth_signup_password_hint": "Mínimo de 8 caracteres, com ao menos uma letra maiúscula, uma minúscula e um número",
  "checkout_auth_signup_password_confirmation_hint": "Repita a senha",
  "checkout_auth_signup_terms_prefix": "Li e concordo com os",
  "checkout_auth_signup_terms_of_use": "Termos de uso",
  "checkout_auth_signup_terms_connector": "e a",
  "checkout_auth_signup_privacy_policy": "Política de privacidade",
  "checkout_auth_signup_secure_purchase": "Compra 100% segura",
  "checkout_auth_signup_confirm_cta": "Confirmar",
  "checkout_auth_signup_email_in_use_title": "E-mail já cadastrado",
  "checkout_auth_signup_email_in_use_message": "Já existe uma conta com este e-mail. Faça login ou recupere sua senha para continuar.",
  "checkout_auth_signup_email_in_use_login": "Fazer login",
  "checkout_auth_signup_email_in_use_recover": "Criar senha",
  "checkout_auth_signup_email_not_found_title": "Não conseguimos confirmar este e-mail",
  "checkout_auth_signup_email_not_found_message": "Confira se ele foi digitado corretamente ou use outro endereço para criar sua conta.",
  "checkout_auth_signup_invalid_cpf": "CPF inválido",
  "checkout_auth_signup_invalid_cnpj": "CNPJ inválido",
  "checkout_auth_signup_invalid_zip_code": "O CEP deve ter 8 dígitos",
  "checkout_auth_signup_invalid_phone": "Insira um celular válido",
  "checkout_auth_signup_weak_password": "A senha deve conter no mínimo 8 caracteres, com ao menos uma letra maiúscula, uma minúscula e um número",
  "checkout_auth_signup_password_mismatch": "As senhas não coincidem",
  "checkout_auth_signup_terms_required": "É necessário aceitar os termos para continuar",
  "checkout_auth_signup_recaptcha_required": "Confirme que você não é um robô",
  "checkout_auth_signup_foreign_cnpj_conflict": "Cadastro de pessoa jurídica não está disponível para estrangeiros",
  "auth_login_submit_cta": "Entrar",
  "auth_login_password_subtitle": "Insira sua senha para acessar sua conta.",
  "auth_login_signup_link": "Não tem uma conta? Cadastre-se",
  "checkout_auth_signup_page_title": "Crie sua conta",
  "checkout_auth_reset_password_page_title": "Redefinição de senha",
  "checkout_auth_recovery_title": "Recuperação de senha",
  "checkout_auth_recovery_email_subtitle": "Digite o e-mail cadastrado e enviaremos um código de 6 dígitos para verificar sua identidade.",
  "checkout_auth_recovery_otp_subtitle": "Enviamos um código de 6 dígitos para o e-mail <strong>{email}</strong>, insira-o no campo abaixo para seguir com a recuperação de senha.",
  "checkout_auth_recovery_new_password_title": "Redefinir senha",
  "checkout_auth_new_password_label": "Nova senha",
  "checkout_auth_confirm_password_label": "Confirmar senha",
  "checkout_auth_password_min_length_helper": "Sua senha deve conter pelo menos 8 caracteres",
  "checkout_auth_password_repeat_helper": "Repita a senha",
  "checkout_auth_reset_password_cta": "Redefinir senha",
  "checkout_auth_back_cta": "Voltar",
  "checkout_auth_did_not_receive_email": "Não recebeu o e-mail?",
  "checkout_auth_resend_email_link": "Clique aqui para reenviar",
  "checkout_auth_otp_code_label": "Insira o código",
  "checkout_auth_otp_code_invalid": "Código incorreto. Confira os dígitos e tente novamente.",
  "checkout_auth_email_placeholder": "Insira seu e-mail",
  "checkout_auth_password_mismatch": "As senhas devem ser iguais",
  "checkout_auth_password_strength": "A senha deve conter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e números",
  "checkout_pix_proceed_description": "Clique em continuar para gerar o QR Code único de pagamento e poder prosseguir com a sua compra.",
  "checkout_continue_pix": "Continuar",
  "checkout_card_owner_cpf_cnpj": "CPF ou CNPJ do Titular do Cartão",
  "checkout_valid_date": "Data de validade (MM/AA)",
  "checkout_complete_purchase": "Concluir compra",
  "checkout_bin_code_validation_error": "O cartão de crédito informado não é qualificado para a aquisição das tarifas selecionadas. Utilize outro cartão.",
  "checkout_disapproved_warning": "Aviso!",
  "checkout_disapproved_intro": "Compra reprovada",
  "checkout_disapproved_try_again": "Tente novamente",
  "checkout_purchase_summary_day": "Dia",
  "checkout_purchase_summary_without_date": "Sem Agendamento",
  "checkout_payment_successful": "Pagamento efetuado com sucesso",
  "checkout_payment_successful_redirect": "Visualizar Compra",
  "checkout_payment_anti_fraud_error": "Verifique se os dados estão corretos, ou utilize outro meio de pagamento.",
  "checkout_payment_transaction_error": "Verifique se os dados estão corretos, ou entre em contato com o banco emissor do cartão.",
  "checkout_payment_generic_transaction_error": "Houve um erro ao processar sua transação. Por favor, aguarde alguns instantes e tente novamente.",
  "checkout_payment_unauthorized_error": "Sessão expirada. Por favor, identifique-se e tente novamente.",
  "checkout_payment_discount_chip": "{percentage}% de desconto",
  "checkout_payment_installments_chip": "Até {count}x sem juros",
  "checkout_payment_card_number": "Número do cartão",
  "checkout_payment_card_holder": "Nome do titular",
  "checkout_payment_card_holder_identity": "CPF ou CNPJ do titular",
  "checkout_payment_card_zip_code": "CEP",
  "checkout_payment_card_postal_code": "Código Postal",
  "checkout_payment_card_security_code": "Código de segurança (CVV)",
  "checkout_payment_card_installments": "Número de parcelas",
  "checkout_secure_purchase": "Compra 100% segura",
  "checkout_additional_info_invalid_cpf": "CPF inválido",
  "checkout_additional_info_invalid_phone": "Telefone inválido",
  "checkout_additional_info_invalid_date": "Data inválida",
  "checkout_additional_info_title": "Preencha informações importantes sobre sua reserva",
  "checkout_additional_info_subtitle": "Utilizamos apenas dados essenciais para a geração do voucher de consumo",
  "checkout_additional_info_fill": "Preencher informações",
  "checkout_additional_info_edit": "Editar",
  "checkout_additional_info_review": "Revisar",
  "checkout_additional_info_filled": "Preenchido",
  "checkout_additional_info_not_filled": "Não preenchido",
  "checkout_additional_info_partially_filled": "{filled} de {total} preenchidos",
  "checkout_additional_info_needs_review": "Revise as informações",
  "checkout_additional_info_continue": "Continuar",
  "checkout_additional_info_next": "Próximo",
  "checkout_additional_info_done": "Concluir",
  "checkout_additional_info_save": "Salvar",
  "checkout_additional_info_cancel": "Cancelar",
  "checkout_additional_info_error_alert": "Revise as informações destacadas",
  "checkout_additional_info_progress": "{filled}/{total}",
  "checkout_payment_card_submit": "Finalizar Compra",
  "checkout_payment_card_validity_must_be_valid": "A validade deve estar no formato MM/AA",
  "checkout_payment_card_foreign_alert_title": "Compras internacionais",
  "checkout_payment_card_foreign_alert_description": "Seu banco pode bloquear compras internacionais. Ative “Aviso de Viagem” ou “Uso Internacional” no app do banco. O banco também pode pedir uma confirmação para autorizar a compra.",
  "checkout_payment_pix_step_generate": "Clique em <strong>Gerar código Pix</strong> para seguir com a compra",
  "checkout_payment_pix_step_confirm": "Confira os dados e realize o pagamento pelo app do seu banco",
  "checkout_payment_pix_secure_purchase": "Compra 100% segura",
  "checkout_payment_pix_generate_button": "Gerar código Pix",
  "checkout_payment_pix_change_method": "Alterar forma de pagamento",
  "checkout_payment_pix_change_method_compact": "Trocar forma de pagamento",
  "checkout_payment_pix_title": "Pague com Pix",
  "checkout_payment_pix_description": "Você pode utilizar a câmera do seu celular para ler QR Code ou copiar o código e pagar no aplicativo do seu banco.",
  "checkout_payment_pix_time_remaining": "Tempo restante para pagar:",
  "checkout_payment_pix_copy_button": "Copiar código",
  "checkout_payment_pix_copied_tooltip": "Código pix copiado",
  "checkout_payment_pix_how_to_title": "Saiba como pagar com Pix:",
  "checkout_payment_pix_how_to_1": "Abra o app ou site do banco de sua preferência.",
  "checkout_payment_pix_how_to_2": "Escolha a opção “pagar com Pix Copia e Cola” ou QR Code.",
  "checkout_payment_pix_how_to_3": "Copie e cole o código ou escaneie o QR Code;",
  "checkout_payment_pix_how_to_4": "Aguarde alguns segundos. Seu pedido será confirmado quando o pagamento for concluído",
  "checkout_payment_pix_expired_title": "O código Pix expirou",
  "checkout_payment_pix_expired_description": "Caso você já tenha realizado o pagamento, seu pedido pode demorar até 5 minutos para ser confirmado",
  "checkout_payment_pix_expired_retry": "Tentar novamente",
  "checkout_payment_pix_receiver_disclaimer": "Ao pagar o Pix, o nome da instituição aparecerá como “<strong>{institution}</strong>”",
  "checkout_payment_account_title": "Conta",
  "checkout_payment_account_edit": "Editar",
  "checkout_payment_step_title": "Pagamento",
  "checkout_payment_step_subtitle": "Escolha uma opção de pagamento:",
  "checkout_phone_verification_alert_message": "Você precisa confirmar o seu telefone",
  "checkout_phone_verification_alert_button": "Confirmar",
  "checkout_sale_change_previous_reservation": "Reserva atual",
  "checkout_sale_change_new_reservation": "Nova reserva",

  "checkout_confirmed_greeting": "Obrigado, {name}!",
  "checkout_confirmed_title": "Pagamento confirmado",
  "checkout_confirmed_description": "Você já pode baixar seus vouchers agora. Eles também foram enviados por e-mail e estão disponíveis na sua conta para acesso quando precisar",
  "checkout_confirmed_additionals": "Adicionais",
  "checkout_confirmed_additionals_overflow": "+{count}",
  "checkout_confirmed_additionals_show_more": "Ver mais",
  "checkout_confirmed_reschedule": "Reagendar",
  "checkout_confirmed_reschedule_available": "Reagendamentos disponíveis: <span>{count}</span>",
  "checkout_confirmed_reschedule_deadline": "Prazo para solicitar reagendamento: <span>{deadline}</span>",
  "checkout_confirmed_reschedule_deadline_antecedence": "Até {antecedence} antes do agendamento",
  "checkout_confirmed_reschedule_expired": "O prazo para realizar reagendamento expirou",
  "checkout_confirmed_reschedule_unavailable": "Não é possível reagendar reservas promocionais. Contate o estabelecimento para mais informações.",
  "checkout_confirmed_reschedule_package_tooltip": "Reservas de pacote são reagendadas em conjunto. Contate o estabelecimento.",
  "checkout_confirmed_vouchers_count": "Vouchers: {count}",
  "checkout_confirmed_vouchers_view_all": "Ver todos",
  "checkout_confirmed_vouchers_pending_tooltip": "Os vouchers ainda estão sendo emitidos. Tente novamente em alguns instantes.",
  "checkout_confirmed_download_all_vouchers": "Baixar todos os vouchers",

  "checkout_order_details_title": "Detalhes do pedido",
  "checkout_order_details_email": "E-mail",
  "checkout_order_details_account_type": "Tipo de conta",
  "checkout_order_details_account_type_individual": "Pessoa física",
  "checkout_order_details_account_type_company": "Pessoa jurídica",
  "checkout_order_details_first_name": "Nome",
  "checkout_order_details_last_name": "Sobrenome",
  "checkout_order_details_representative_first_name": "Nome do representante legal",
  "checkout_order_details_representative_last_name": "Sobrenome do representante legal",
  "checkout_order_details_corporate_name": "Razão social",
  "checkout_order_details_country": "País de origem",
  "checkout_order_details_cpf": "CPF",
  "checkout_order_details_cnpj": "CNPJ",
  "checkout_order_details_national_document": "Documento nacional",
  "checkout_order_details_passport": "Passaporte",
  "checkout_order_details_phone": "Celular",
  "checkout_order_details_payment_method": "Método de pagamento",
  "checkout_order_details_installments": "Número de parcelas",
  "checkout_order_details_installments_value": "{count}x de {amount}",
  "checkout_order_details_zip_code": "CEP",

  "checkout_payment_method_credit_card": "Cartão de crédito",
  "checkout_payment_method_debit_card": "Cartão de débito",
  "checkout_payment_method_pix": "Pix",
  "checkout_payment_method_post_paid": "Faturado",

  "checkout_vouchers_modal_code": "Código",
  "checkout_vouchers_modal_password": "Senha",
  "checkout_vouchers_modal_status": "Status",
  "checkout_vouchers_modal_status_open": "Não consumido",
  "checkout_vouchers_modal_status_consumed": "Consumido",
  "checkout_vouchers_modal_status_revoked": "Cancelado",
  "checkout_vouchers_modal_status_pending": "Aguardando confirmação",
  "checkout_vouchers_modal_download": "Baixar voucher",
  "checkout_vouchers_modal_tariff_quantity": "{count}x {name}",

  "checkout_payment_gateway_mismatch_error_title": "Não foi possível seguir para o pagamento",
  "checkout_payment_gateway_mismatch_error_description": "Houve um erro nas informações financeiras do responsável pela venda. Para seguir com sua compra, entre em contato com nosso suporte.",
  "checkout_payment_gateway_mismatch_error_ok": "OK",
  "checkout_payment_gateway_blocked_buyer_error_title": "Não foi possível processar o pagamento",
  "checkout_payment_gateway_blocked_buyer_error_helper_text": "Você excedeu o limite máximo de tentativas. Para seguir com sua compra utilize outro método de pagamento",

  "checkout_error_foreignCustomerNotAllowed": "Este aplicativo não permite compras de estrangeiros. Por favor, entre em contato com o estabelecimento para mais informações.",
  "checkout_foreign_buyer_alert_badge": "IMPORTANTE",
  "checkout_foreign_buyer_alert_title": "Compras internacionais",
  "checkout_foreign_buyer_alert_description": "Seu banco pode bloquear compras internacionais. Ative <strong>“Aviso de Viagem”</strong> ou <strong>“Uso Internacional”</strong> no app do banco. O banco também pode pedir <strong>uma confirmação para autorizar a compra.</strong>",

  "timeout_error_title": "Não foi possível se comunicar com o servidor",
  "timeout_error_description": "Ops, tivemos um problema na comunicação com o servidor. Aguarde alguns instantes e tente novamente, por favor.",
  "timeout_error_ok": "OK",

  "checkout_pix_payment_insufficient_amount_title": "Valor insuficiente para pagamento via Pix",
  "checkout_pix_payment_insufficient_amount_description": "Adicione mais produtos ao carrinho ou utilize outro método de pagamento",

  "adder_dataSelected": "Data selecionada: ",
  "adder_buy": "Comprar",
  "adder_goBack": "voltar",
  "adder_quantity": "Quantidade",
  "adder_hour": "Selecione um horário",
  "adder_unavailableQuantity": "Quantidade não disponível",
  "adder_outOfStock": "Esgotado",
  "adder_additionals": "Adicionais",
  "adder_additionals_perPerson": "p/ tarifa",
  "adder_additionals_remain": "Restam",
  "adder_additionals_soldOff": "Esgotado",
  "adder_productAddedToCart": "Produto adicionado ao carrinho!",
  "adder_productNotAddedToCart": "Erro ao adicionar produto ao carrinho",
  "adder_seeCart": "Ver meu carrinho",
  "adder_perPerson": "por pessoa",
  "adder_singleErrorLabel": "A quantidade selecionada para esta tarifa não está disponível",
  "adder_multipleErrorLabel": "A quantidade das tarifas selecionadas ultrapassou o limite para esta data",
  "adder_dependent_tariff": "Dependente",
  "adder_dependent_tariff_selection_error": "Selecione ao menos uma tarifa que não seja dependente para prosseguir",
  "adder_hours_unavailable_error": "Horários indisponíveis para a quantidade de tarifas selecionadas",
  "adder_additionals_custom_type_quantity_placeholder": "Digite a quantidade desejada",
  "adder_additionals_custom_type_quantity_error": "A quantidade deve ser maior que zero",
  "adder_additionals_custom_type_max_quantity_error": "A quantidade máxima permitida é {maxQuantity}",
  "adder_seats_missing_tariffs_unavailable_error": "Não encontramos lugares disponíveis para estas tarifas e horário selecionados. Para prosseguir, adicione mais {missing} tarifa(s) à sua seleção ou tente outro horário disponível.",
  "adder_seats_unavailable_error": "Não encontramos lugares disponíveis para as tarifas e horário selecionados. Para prosseguir, selecione outra data/horário disponível.",
  "adder_error_generic": "Não foi possível adicionar esta seleção ao carrinho. Revise os dados e tente novamente.",
  "adder_error_tariff_quantity_limit": "A quantidade selecionada ultrapassa o limite permitido para esta tarifa. Reduza a quantidade para continuar.",
  "adder_error_tariff_unavailable": "Não há disponibilidade para a quantidade selecionada. Reduza a quantidade ou escolha outra data/horário.",
  "adder_error_additional_unavailable": "Não há disponibilidade para os adicionais selecionados. Revise a seleção para continuar.",
  "adder_error_schedule_unavailable": "A data ou horário selecionado não está mais disponível. Escolha outra opção para continuar.",
  "adder_error_seats_unavailable": "Não há lugares suficientes para a quantidade selecionada. Reduza a quantidade ou escolha outro horário.",
  "adder_error_seats_missing_capacity": "Faltam {missing} lugar(es) para a quantidade selecionada neste horário. Reduza a quantidade ou escolha outro horário.",
  "adder_error_product_unavailable": "Este produto não está disponível para compra no momento.",
  "adder_tariff_verification_field_required": "Este campo é obrigatório",
  "adder_tariff_verification_validation_error": "Dados de comprovações inválidos",
  "adder_tariff_verification_document_validation_error": "O número do documento informado não é válido ou não atende aos critérios exigidos para esta tarifa.",
  "adder_tariff_verification_date_validation_error": "A data informada não atende aos critérios exigidos para esta tarifa.",

  "sale_totalValue": "Valor total: ",
  "sale_termExpired": "O prazo para o pagamento deste pedido expirou.",
  "sale_printAll": "Imprimir todos",
  "sale_print": "Imprimir",
  "sale_productColumn": "Produto",
  "sale_dateColumn": "Data",
  "sale_hourColumn": "Hora",
  "sale_quantityColumn": "Qtd",
  "sale_codeColumn": "Voucher",
  "sale_passwordColumn": "Senha",
  "sale_stateColumn": "Estado",
  "sale_noAvailableReservation": "Nenhuma reserva disponível!",
  "sale_reschedule": "Reagendar",
  "sale_unavailableReschedule": "Reagendamento indisponível!",
  "sale_awaitingDate": "Aguardando uma data...",
  "sale_consumed": "Consumido",
  "sale_open": "Em aberto",
  "sale_goBack": "Voltar",

  "seatMap_selectOneTime": "Selecione apenas um horário",
  "seatMap_tariffUnits": "Unidade(s)",
  "seatMap_pendingAllocationQuantity": "Quantidade alocada:",
  "seatMap_pendingTariffAllocation": "Algumas tarifas ainda não foram alocadas",
  "seatMap_resourceMinValue": "Valor do lugar",
  "seatMap_filledCapacity": "lugares",
  "seatMap_resourceSubAllocationNotice": "A quantidade de tarifas alocadas na mesa é menor do que o permitido, selecione outra mesa.",
  "seatMap_resourceReservationPrice": "Extra por lugares",
  "seatMap_totalPrice": "Total",
  "seatMap_canvas_subtitles": "Legendas",
  "seatMap_tariff_price_cents": "Valor das tarifas",
  "seatMap_selectSeat": "Selecione o lugar",

  "awaiting_confirmation": "Aguardando confirmação",
  "created": "Em aberto",
  "pending": "Pendente",
  "expired": "Expirada",
  "confirmed": "Confirmado",
  "payment_complete": "Pagamento confirmado",
  "payment_voided": "Pagamento estornado",
  "payment_chargeback": "Cancelada",
  "payment_charged_back": "Cancelada",
  "payment_denied": "Cancelada",
  "canceled": "Cancelada",
  "available": "Disponível",
  "selected": "Selecionado",
  "blocked": "Bloqueado",
  "unavailable": "Indisponível",
  "no_option_found": "Nenhuma opção encontrada",

  "january": "Janeiro",
  "february": "Fevereiro",
  "march": "Março",
  "april": "Abril",
  "may": "Maio",
  "june": "Junho",
  "july": "Julho",
  "august": "Agosto",
  "september": "Setembro",
  "october": "Outubro",
  "november": "Novembro",
  "december": "Dezembro",
  "monday": "Segunda-Feira",
  "tuesday": "Terça-Feira",
  "wednesday": "Quarta-Feira",
  "thursday": "Quinta-Feira",
  "friday": "Sexta",
  "saturday": "Sábado",
  "sunday": "Domingo",

  "cart_item_remove_error": "Erro ao remover o item do carrinho. Tente novamente ou entre em contato com o estabelecimento.",
  "cart_package_error": "Algum item foi alterado ou removido pelo vendedor, remova o item do carrinho",
  "cart_package_details": "Detalhes dos produtos",
  "cart_item_price_summary_previous": "Preço anterior",
  "cart_iconLabel": "Seu carrinho possui {quantity} itens",
  "cart_loading": "Carregando carrinho de compras",
  "cart_header": "Carrinho de Compras",
  "cart_totalLabel": "Total",
  "cart_subtotal": "Subtotal",
  "cart_final_value": "Valor final",
  "cart_coupon_text": "Cupom",
  "cart_itemErrorWarning": "O item foi alterado pelo provedor. Remova do carrinho para continuar.",
  "discount_fallback_warning_message": "O desconto deste produto foi alterado pelo vendedor",
  "cart_value": "Valor",
  "cart_checkout": "Finalizar Compra",
  "cart_discount": "Desconto",
  "cart_apply": "Aplicar",
  "cart_cancel": "Remover",
  "cart_openAreaApplyVoucher": "Abrir área para aplicar o cupom",
  "cart_closeAreaApplyVoucher": "Fechar área de aplicar o cupom",
  "cart_voucherTitle": "Cupom de Desconto",
  "cart_selectedDate": "Data",
  "cart_selectedLanguage": "Idioma",
  "cart_selectedTariff": "Tarifa",
  "cart_selectedResources": "Lugar selecionado",
  "cart_additionals": "Adicionais",
  "cart_itens": "Itens",
  "cart_backToHome": "Voltar a Pagina inicial",
  "cart_pleaseWait": "Por favor aguarde!",
  "cart_yourCartIsEmpty": "O seu carrinho está vazio",
  "cart_addProductInstruction": "Adiciona um produto ao carrinho",
  "cart_closeCart": "Fechar modal do carrinho de compras",
  "cart_quantity": "Quantidade",
  "cart_remove_discount_button": "Remover",
  "cart_discount_coupon_button_title": "Adicionar cupom de desconto",
  "cart_discount_coupon_submit_button": "ADICIONAR",
  "cart_discount_coupon_applied_succefully": "Cupom de desconto aplicado",
  "cart_discount_coupon_product": "Somente ao produto:",
  "cart_discount_coupon_product_list": "Somente aos produtos:",
  "cart_package_date": "Data:",
  "cart_package_tariff": "Tarifas:",
  "cart_package_previous_price": "Preço anterior",
  "cart_package_discount": "Desconto",
  "cart_package_total": "Total",
  "cart_package_product_details": "Detalhes dos produtos",

  "adder_step_calendar": "Selecione uma data",
  "adder_step_tariff": "Selecione uma tarifa",
  "adder_selected_date": "Data Selecionada",
  "adder_step_additional": "Selecione os adicionais",
  "adder_step_seat_map": "Selecione um Lugar",
  "adder_step_finish": "Adicionar ao carrinho",
  "adder_step_package_quantity": "Selecione a quantidade",
  "adder_priceAccordingToSchedule": "de acordo com horário",
  "adder_day": "Dia",
  "adder_night": "Noite",
  "adder_price_per_unit": "Preço por unidade",
  "adder_goBackFooter": "Voltar",
  "adder_goForwardsFooter": "Continuar",
  "adder_purchaseButton": "Comprar",
  "adder_serviceFee": "Podem ser cobradas taxas",
  "adder_selectedTariff": "Tarifa Selecionada",
  "adder_selectedResources": "Lugar selecionado",
  "adder_legend_current": "Dia corrente",
  "adder_legend_available": "Disponível",
  "adder_legend_unavailable": "Indisponível",
  "adder_legend_suggested_prices": "Preços sujeito a mudanças",
  "adder_legend_suggested_prices_tooltip": "O preço exibido pode variar dependendo do horário ou da tarifa escolhida",
  "adder_legend_busy": "Alta temporada",
  "adder_unavailableTariffNotice": "Esgotado",
  "adder_tryAgain": "Tentar novamente",
  "adder_price_from": "De",
  "adder_price_to": "Por",
  "adder_updating_price": "Atualizando…",
  "adder_price_update_failed": "Não foi possível atualizar o preço. Mostrando o último valor.",

  "terms_of_use": "Termos de Uso",
  "privacy_policy": "Política de Privacidade",

  "direct_link_sale_title": "Carrinho",
  "direct_link_payment_title": "Pagamento",
  "direct_link_pay_button": "Pagar",
  "direct_link_finished_payment_message": "Pagamento finalizado",
  "direct_link_finished_sale_message": "Compra finalizada",
  "direct_link_cancelled_message": "Link cancelado",
  "direct_link_checkout_error_couponHasUsesLeft": "O cupom utilizado no carrinho não possui mais usos disponíveis. Por favor, entre em contato com o estabelecimento para mais informações.",
  "direct_link_checkout_error_resourceMustBeAvailable": "Lugar não disponível",
  "direct_link_checkout_error_tariffOccupationMustBeRespected": "Não há mais vagas disponíveis para esta tarifa no horário escolhido",

  "coupon_code": "Cupom inválido!",
  "coupon_expires_at": "Cupom com data de limite expirada",
  "coupon_max_use": "Cupom ultrapassou o limite máximo de usos",
  "coupon_max_use_per_user": "Ops! Você já utilizou este cupom o número máximo de vezes permitidas",
  "coupon_invalid_for_these_products": "Cupom não aplicável aos produtos selecionados.",

  "open_purchase_title": "Finalizar o pagamento",
  "open_purchase_description": "Você tem uma compra não finalizada, deseja continuar?",
  "open_purchase_button_text": "Sim",

  "direct_link_required_field": "Campo obrigatório",

  "customer_form_invalid_document": "Documento inválido",
  "customer_form_email_does_not_match": "E-mail não confere",
  "customer_form_invalid_birthdate": "Data de nascimento inválida",

  "direct_link_invalid_message": "Link inválido",
  "direct_link_expired_message": "Link expirado",

  "direct_link_auth_step_title": "Dados de contato",
  "direct_link_payment_step_title": "Pagamento",
  "direct_link_summary_title_payment": "Resumo do pagamento",
  "direct_link_summary_title_sale": "Resumo da compra",

  "direct_link_auth_message": "Seus ingressos serão enviados para o email informado. Insira um email válido",
  "direct_link_auth_email_label": "Email",
  "direct_link_auth_continue": "Continuar",

  "direct_link_auth_login_title": "Entrar",
  "direct_link_auth_login_or": "Ou",
  "direct_link_auth_login_with_otp": "Entrar com chave de acesso",
  "direct_link_auth_login_with_password": "Entrar com senha",

  "direct_link_user_form_email_label": "Email",
  "direct_link_user_form_email_confirmation_label": "Confirmar e-mail",
  "direct_link_user_form_name_label": "Nome",
  "direct_link_user_form_representative_legal_name_label": "Nome do representante legal",
  "direct_link_user_form_lastname_label": "Sobrenome",
  "direct_link_user_form_representative_legal_lastname_label": "Sobrenome do representante legal",
  "direct_link_user_form_phone_label": "Telefone",
  "direct_link_user_form_cpf_identity_label": "CPF",
  "direct_link_user_form_cnpj_identity_label": "CNPJ",
  "direct_link_user_form_identity_label": "CPF/CNPJ",
  "direct_link_user_form_birthday_label": "Data de nascimento",
  "direct_link_user_form_zip_code_label": "CEP",
  "direct_link_user_form_corporate_name_label": "Razão social",
  "direct_link_user_form_terms_message": "Ao prosseguir com a compra você declara estar de acordo com os ",
  "direct_link_user_form_terms_message_use_terms": "Termos de Uso",
  "direct_link_user_form_terms_message_and": " e ",
  "direct_link_user_form_terms_message_privacy_policy": "Política de Privacidade",
  "direct_link_user_form_continue": "Continuar",
  "direct_link_user_form_identity_type_cpf": "Sou pessoa física",
  "direct_link_user_form_identity_type_cnpj": "Sou pessoa jurídica",
  "direct_link_user_form_corporate_name": "Razão social",
  "direct_link_user_form_is_foreign": "Sou estrangeiro",
  "direct_link_user_form_nationality": "Nacionalidade",
  "direct_link_user_form_document": "Documento",
  "direct_link_user_form_identity_national_document": "Documento nacional",
  "direct_link_user_form_identity_passport": "Passaporte",

  "direct_link_password_form_title": "Insira a senha para entrar",
  "direct_link_password_form_password_label": "Senha",
  "direct_link_password_form_login": "Entrar",
  "direct_link_password_form_forgot_password": "Esqueceu a senha?",

  "direct_link_forgot_password_modal_title": "Redefinir senha",

  "direct_link_reset_password_form_title": "Insira o código que te enviamos por e-mail",
  "direct_link_reset_password_code_label": "Código de acesso",
  "direct_link_reset_password_code_expires": "O código expira em",
  "direct_link_reset_password_sending_code": "Enviando código...",
  "direct_link_reset_password_resend_code": "Reenviar o código",
  "direct_link_reset_password_cancel": "Cancelar",
  "direct_link_reset_password_confirm": "Confirmar",

  "direct_link_change_password_form_title": "Digite a nova senha",
  "direct_link_change_password_form_password_label": "Nova senha",
  "direct_link_change_password_form_password_confirmation_label": "Confirmar nova senha",
  "direct_link_change_password_form_cancel": "Cancelar",
  "direct_link_change_password_form_confirm": "Confirmar",
  "direct_link_change_password_password_match": "As senhas não coincidem",

  "direct_link_auth_login_otp_form_title": "Insira o código que te enviamos por e-mail",
  "direct_link_auth_login_otp_form_code_label": "Código de acesso",
  "direct_link_auth_login_otp_form_login": "Entrar",
  "direct_link_auth_login_otp_form_code_expires": "O código expira em",
  "direct_link_auth_login_otp_form_sending_code": "Enviando código...",
  "direct_link_auth_login_otp_form_resend_code": "Reenviar o código",

  "direct_link_summary_date_and_time": "Data e hora",
  "direct_link_summary_subtotal": "Subtotal",
  "direct_link_summary_coupon": "Cupom",
  "direct_link_summary_discount": "Desconto",
  "direct_link_summary_total": "Total",

  "direct_link_validate_phone_message": "Você precisa validar o seu telefone",
  "direct_link_validate_phone_validate": "Validar",
  "direct_link_validate_phone_modal_title": "Informar chave de acesso",

  "direct_link_phone_verification_form_title": "Insira o código que te enviamos por SMS para telefone:",
  "direct_link_phone_verification_form_code_label": "Código de acesso",
  "direct_link_phone_verification_form_code_expires": "O código expira em",
  "direct_link_phone_verification_form_sending_code": "Enviando código...",
  "direct_link_phone_verification_form_resend_code": "Reenviar o código",
  "direct_link_phone_verification_form_submit": "Continuar",

  "direct_link_card_form_submit": "Finalizar Compra",
  "direct_link_card_form_identity_must_be_valid": "O número deve ser válido",
  "direct_link_card_form_postal_code_must_have_8_digits": "O CEP deve ter 8 dígitos",
  "direct_link_card_form_postal_code_must_be_valid": "O CEP deve ser válido",
  "direct_link_card_form_card_number_must_be_valid": "O cartão deve ser válido",
  "direct_link_card_form_card_brand_not_accepted": "A bandeira do cartão não é aceita",
  "direct_link_card_form_card_expired": "O cartão não pode estar vencido",
  "direct_link_card_form_validity_placeholder": "MM/AA",
  "direct_link_card_form_holder_helper": "Conforme consta no cartão",

  "direct_link_pix_form_step_1_title": "Você estará pagando com PIX",
  "direct_link_pix_form_step_1_description": "A confirmação de pagamento é realizada em poucos minutos. Utilize o aplicativo do seu banco para pagar.",
  "direct_link_pix_form_step_1_pix_amount": "Valor no PIX:",
  "direct_link_pix_form_step_1_finish": "Finalizar compra",

  "direct_link_pix_form_step_2_instruction": "Abra o seu aplicativo de pagamento e escolha a opção <strong>Ler Código QR</strong>",
  "direct_link_pix_form_step_2_camera_instruction": "Aponte a câmera do celular para o Código QR",
  "direct_link_pix_form_step_2_copy_code": "Copiar código",
  "direct_link_pix_form_step_2_code_copied": "Copiado!",
  "direct_link_pix_form_step_2_verifying_payment": "Verificando o pagamento",

  "direct_link_pix_form_steps_step_1": "Finalize a compra clicando em \"Finalizar compra\"",
  "direct_link_pix_form_steps_step_2": "Leia o Código QR com o app do seu banco ou copie o chave PIX",
  "direct_link_pix_form_steps_step_3": "Após a confirmação do pagamento sua reserva estará confirmada",

  "direct_link_payment_success_alert": "Pagamento efetuado!",
  "direct_link_payment_success_message": "Temos o prazer de informar que seu pagamento foi recebido com sucesso.",
  "direct_link_payment_success_voucher_message": "Para mais detalhes, baixe o seu Voucher.",
  "direct_link_payment_success_download_vouchers": "Baixar todos os vouchers",

  "direct_link_min_code_length": "O código deve ter no mínimo 6 caracteres",
  "direct_link_max_code_length": "O código deve ter no máximo 6 caracteres",

  "direct_link_min_password_length": "A senha deve ter no mínimo 8 caracteres",
  "direct_link_password_strength": "A senha deve conter no mínimo 8 caracteres, com ao menos uma letra maiúscula e uma letra minúscula",

  "direct_link_user_form_terms_modal_title": "Termos de Uso",
  "direct_link_user_form_privacy_policy_modal_title": "Políticas de Privacidade",

  "direct_link_zipCode_max_length_error": "O CEP deve ter 8 dígitos",

  "cashback_growth_modal_title": "Sua compra gerou cashback!",
  "cashback_growth_modal_store_hint": "Vale em <strong>parques</strong>, <strong>restaurantes</strong> e <strong>passeios parceiros</strong>.",
  "cashback_growth_modal_deadline": "Resgate seu cashback pelo WhatsApp. O prazo para usar começa quando você resgata.",
  "cashback_growth_redeem_whatsapp": "Resgatar pelo WhatsApp",
  "cashback_growth_redeem_short": "Resgatar",
  "cashback_growth_decline": "Não quero cashback",
  "cashback_growth_card_with_name": "{name}, sua compra gerou cashback para usar em restaurantes, passeios e atrações na Serra Gaúcha. O prazo para usar começa quando você resgata.",
  "cashback_growth_card_without_name": "Sua compra gerou cashback para usar em restaurantes, passeios e atrações na Serra Gaúcha. O prazo para usar começa quando você resgata.",

  "partnership_banner_discount": "{value} de desconto!",
  "partnership_banner_message": "Compre agora e ganhe {value} de desconto de {affiliateName}! O cupom <strong>{couponCode}</strong> será aplicado automaticamente no seu carrinho.",
  "partnership_banner_continue": "Continuar",

  "recaptcha_validation_error": "Por favor, confirme que você não é um robô",

  "phone_verification_title": "Quase lá!",
  "phone_verification_subtitle": "Informe o código enviado via SMS para o telefone",
  "phone_verification_submit_button": "Entrar",

  "invalid_value": "Cupom inválido!",
  "coupon_is_active": "Cupom não aplicável para estas datas.",
  "coupon_has_uses_left": "Cupom ultrapassou o limite máximo de usos",
  "coupon_has_customer_uses_left": "Ops! Você já utilizou este cupom o número máximo de vezes permitidas",
  "coupon_has_some_products": "Cupom não aplicável aos produtos selecionados!",
  "coupon_purchase_min_amount_cents_not_reached": "Valor mínimo do cupom não atingido. Adicione mais itens ao carrinho para prosseguir com o desconto.",
  "coupon_has_some_valid_item": "Cupom não aplicável aos produtos selecionados!",

  "product_package_adder_product_list_title": "Produtos",
  "product_package_adder_total": "Total",
  "product_package_adder_selection_step_calendar": "Escolha uma data para: ",
  "product_package_adder_selection_step_tariff": "Escolha uma tarifa para: ",
  "product_package_adder_selection_step_seat_map": "Escolha lugares para: ",
  "product_package_adder_selection_step_additional": "Escolha adicionais para: ",
  "product_package_adder_add_to_cart_button": "Adicionar ao carrinho",
  "product_package_adder_complete_selection_description": "Todos os produtos do Combo {packageName} com {productQuantity} atividades foram configurados",
  "product_package_cancel_modal_title": "Deseja fechar o pacote?",
  "product_package_cancel_modal_description": "Fechar a configuração do pacote irá remover todos os produtos configurados.",
  "product_package_cancel_modal_action_no": "Não",
  "product_package_cancel_modal_action_yes": "Sim",
  "product_package_error_while_load_package_data": "Ocorreu um erro ao carregar os dados do pacote.",
  "product_package_error_empty_package": "Parece que este pacote não possui produtos disponíveis para venda. Ente em contato com o estabelecimento.",
  "product_package_error_has_inactive_product": "Ops! Um dos produtos deste pacote está indisponível para venda. Entre em contato com o estabelecimento.",
  "product_package_error_while_load_package_products_data": "Ocorreu um erro ao carregar os produtos do pacote. Entre em contato com o estabelecimento.",
  "product_package_single_booking_unavailable": "Este pacote está indisponível para as opções selecionadas.",
  "product_package_single_booking_quantity_step_title": "Escolha a quantidade de tarifas para todos os produtos do pacote",
  "product_package_single_booking_chosen_date": "Data escolhida",
  "product_package_single_booking_additional_fees": "Podem ser cobradas taxas adicionais",
  "product_package_adder_sold_by": "Vendido por: {owner}",

  "tds_generic_error": "Erro ao processar o pagamento",
  "tds_transaction_failed": "Falha no pagamento",
  "tds_transaction_denied": "Pagamento negado",
  "tds_invalid_transactable": "Transação inválida",

  "currency_warning_message": "Os valores são mostrados em outras moedas apenas para referência. A cobrança será feita em Real (BRL).",

  "cart_serviceFee": "Taxa de serviço",
  "cart_serviceFee_tooltip": "A taxa de serviço serve para a manutenção e operação da plataforma.",

  "product_booking_add_to_cart": "Adicionar ao carrinho",
  "product_booking_date_placeholder": "Selecione uma data",
  "product_booking_language_placeholder": "Selecione o idioma",
  "product_booking_attribute_placeholder": "Selecione o {attribute}",
  "product_booking_attribute_no_option_found": "Nenhuma opção encontrada",
  "product_booking_attribute_loading": "Carregando...",
  "product_booking_attribute_pickup_zone_label": "Local de embarque",
  "product_booking_tariff_placeholder": "Selecione a tarifa",
  "product_booking_tariff_summary": "{count, plural, one {{count, number}x Tarifa} other {{count, number}x Tarifas}}",
  "product_booking_additionals_summary": "{count, plural, one {{count, number}x Adicional} other {{count, number}x Adicionais}}",
  "product_booking_service_fee_note": "Podem ser cobradas taxas",
  "product_booking_no_tariffs": "Nenhuma tarifa disponível para esta data",
  "product_booking_tariff_max_availability_reached": "Quantidade máxima disponível para este produto foi atingida",
  "product_booking_trust_instant_title": "Confirmação instantânea",
  "product_booking_trust_instant_description": "Recebe seu voucher imediatamente por e-mail.",
  "product_booking_trust_secure_title": "Pagamento seguro",
  "product_booking_trust_secure_description": "Seus dados estão protegidos.",
  "product_booking_price_in_up_to_installments": "Em até {count}x",
  "product_booking_price_interest_free": "Sem juros",
  "product_booking_price_or_at_sight": "ou {price} à vista",
  "product_booking_price_starting_from": "A partir de",
  "product_booking_price_at_sight_label": "À vista",
  "product_booking_price_at_sight_compact": "{price} à vista",
  "product_booking_total_label": "TOTAL DA RESERVA",
  "product_booking_total_at_sight_suffix": "à vista",
  "product_booking_view_summary": "Ver resumo",
  "product_booking_additionals": "Selecione o adicional (Opcional)",
  "product_booking_quantity_minus": "Diminuir quantidade",
  "product_booking_quantity_plus": "Aumentar quantidade",
  "product_booking_select_date_first": "Selecione uma data primeiro",
  "product_booking_select_language_first": "Selecione um idioma primeiro",
  "product_booking_select_tariff_first": "Selecione a tarifa primeiro",
  "product_booking_select_time_first": "Selecione uma hora primeiro",
  "product_booking_select_seat_map_first": "Conclua a seleção de lugares primeiro",
  "product_booking_select_additionals_first": "Preencha os adicionais obrigatórios primeiro",
  "product_booking_select_attribute_first": "Selecione {attribute} primeiro",
  "product_booking_trending_reservations": "{count, plural, =0 {0 pessoas reservaram} one {{count, number} pessoa reservou} other {{count, number} pessoas reservaram}} nas últimas 24hrs",
  "product_upsell_modal_title": "Adicionado ao carrinho!",
  "product_upsell_modal_description": "Aproveite para garantir agora outras experiências incríveis recomendadas pelos nossos especialistas.",
  "product_upsell_sold_by": "Vendido por: {owner}",
  "product_upsell_price_prefix": "A partir de",
  "product_upsell_add_offer": "Adicionar {product}",
  "product_upsell_remove_offer": "Remover {product}",
  "product_upsell_selected_count": "{count, plural, one {{count, number} item selecionado} other {{count, number} itens selecionados}}",
  "product_upsell_no_thanks": "Não, obrigado",
  "product_upsell_continue": "Continuar",
  "upsell_booking_cancel_title": "Descartar upsell?",
  "upsell_booking_cancel_description": "Se fechar agora, todos os produtos adicionais serão descartados e você será redirecionado ao carrinho com apenas o produto principal.",
  "upsell_booking_cancel_action_no": "Continuar",
  "upsell_booking_cancel_action_yes": "Descartar",
  "upsell_booking_product_list_title": "Produtos selecionados",
  "upsell_booking_completed_description": "Todos os produtos foram configurados",
  "code_input_value_label": "Valor {index} de {length}",

  "checkout_payment_error_declined_title": "Compra reprovada",
  "checkout_payment_error_declined_body": "Não foi possível concluir sua compra com este cartão.",
  "checkout_payment_error_declined_body_pix": "Temos também a opção de pagamento via Pix, que são aprovados instantaneamente e garantem sua reserva agora.",
  "checkout_payment_error_issuer_title": "Pagamento não autorizado pelo banco",
  "checkout_payment_error_issuer_body": "O banco recusou a transação. Verifique os dados do cartão ou confirme a compra no app do seu banco.",
  "checkout_payment_error_issuer_body_pix": "Você também pode pagar com Pix para aprovação imediata.",
  "checkout_payment_error_secondary_pix": "Pagar com PIX",
  "checkout_payment_error_retry": "Tentar novamente",
  "checkout_payment_error_expired_title": "Seu pedido expirou",
  "checkout_payment_error_expired_description": "O tempo para concluir este pagamento acabou. Para garantir seus produtos, basta selecionar os produtos novamente e finalizar sua compra.",
  "checkout_payment_error_expired_retry": "Tentar novamente"
}
